{
  "January": "enero",
  "February": "febrero",
  "March": "marzo",
  "April": "abril",
  "May": "mayo",
  "June": "junio",
  "July": "julio",
  "August": "agosto",
  "September": "septiembre",
  "October": "octubre",
  "November": "noviembre",
  "December": "diciembre",
  "JanAbbr": "enero",
  "FebAbbr": "feb.",
  "MarAbbr": "marzo",
  "AprAbbr": "abr.",
  "MayAbbr": "mayo",
  "JunAbbr": "jun.",
  "JulAbbr": "jul.",
  "AugAbbr": "agosto",
  "SepAbbr": "set.",
  "OctAbbr": "oct.",
  "NovAbbr": "nov.",
  "DecAbbr": "dic.",
  "Today": "Hoy",
  "Yesterday": "El dia de ayer",
  "ThisWeek": "Esta Semana",
  "LastWeek": "La Semana Pasada",
  "Last7Days": "Los últimos 7 días",
  "ThisMonth": "Este Mes",
  "LastMonth": "El Mes Pasado",
  "Su": "Do",
  "Mo": "Lu",
  "Tu": "Ma",
  "We": "Mi",
  "Th": "Ju",
  "Fr": "Vi",
  "Sa": "Sa"
}
